import script from "./Media.vue?vue&type=script&setup=true&lang=js"
export * from "./Media.vue?vue&type=script&setup=true&lang=js"

import "./Media.vue?vue&type=style&index=0&id=8dc25a7c&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dc25a7c"]])

export default __exports__